import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';
import { formatCount } from '@/utils/format';

export default function TickerBar() {
  const loop = [...topics, ...topics];

  return (
    <div className="overflow-hidden border-b border-secondary-700 bg-secondary-900 py-2.5">
      <div className="marquee-track flex w-max items-center gap-10">
        {loop.map((topic, index) => (
          <Link
            key={`${topic.id}-${index}`}
            to={`/topic/${topic.id}`}
            className="flex shrink-0 items-center gap-2 text-xs text-secondary-200 transition-colors hover:text-background-50"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" aria-hidden="true" />
            <span className="whitespace-nowrap">{topic.title}</span>
            <span className="whitespace-nowrap text-secondary-400">热度 {formatCount(topic.heat)}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}